import firebase from 'firebase/compat/app';
import withoutNulls from '../../api/search/withoutNulls';
import STORE_CONSTANTS from '../constants';

const fixedPeriodSchemeConverter = {
  toFirestore(scheme: FixedPeriods.Scheme): firebase.firestore.DocumentData {
    return withoutNulls({ ...scheme });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<FixedPeriods.Scheme>,
    options: firebase.firestore.SnapshotOptions,
  ): FixedPeriods.Scheme {
    const data = {
      ...snapshot.data(options),
    };

    if (!data.name) {
      data.name = snapshot.id;
    }

    if (!data.id) {
      data.id = snapshot.id;
    }

    return data;
  },
};

const getFixedPeriodSchemesRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.FIXED_PERIODS_COLLECTION)
    .withConverter(fixedPeriodSchemeConverter);
};

export default getFixedPeriodSchemesRef;
